<template>
	<app-panel class="mt-3">
		<div class="divide-y space-y-4">
			<contact-card
				v-if="journey.site_contact_telephone"
				title="Site Contact"
				:name="journey.site_contact_name"
				:number="journey.site_contact_telephone"
				data-testid="site-contact" />

			<Transition>
				<contact-card
					v-if="showCustomerContact && journey.customer_contact_telephone"
					title="Customer Contact"
					:name="journey.customer_contact_name"
					:number="journey.customer_contact_telephone"
					data-testid="customer-contact"
					class="pt-4" />
			</Transition>
		</div>

		<button
			v-if="journey.customer_contact_telephone && !showCustomerContact"
			class="text-gray-400 underline hover:text-gray-700 text-xs mt-2"
			@click="showCustomerContact = true">
			Show Customer Contact
		</button>
	</app-panel>
</template>

<script lang="ts" setup>
	import { Journey } from '@/data/schema/journey'
	import { onMounted, ref } from 'vue'
	import ContactCard from './ContactCard.vue'

	const showCustomerContact = ref(false)

	const props = defineProps({
		journey: {
			type: Journey,
			default: ''
		}
	})

	onMounted(() => {
		// has customer but no site, show customer
		if (!props.journey.site_contact_telephone && props.journey.customer_contact_telephone) {
			showCustomerContact.value = true
		}
	})
</script>

<style>
	.v-enter-active,
	.v-leave-active {
		transition: opacity 0.5s ease;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
	}
</style>
